import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { listInvoices, type InvoiceFilters } from '../api/invoices.service';
export function useInvoicesListQuery(filters: InvoiceFilters) {
  return useQuery({ queryKey: queryKeys.invoices.list(filters), queryFn: () => listInvoices(filters) });
}
